import { render } from "./EvaluationOfPatient.vue?vue&type=template&id=a7840606&scoped=true&ts=true"
import script from "./EvaluationOfPatient.vue?vue&type=script&lang=ts"
export * from "./EvaluationOfPatient.vue?vue&type=script&lang=ts"

import "./EvaluationOfPatient.vue?vue&type=style&index=0&id=a7840606&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/HeThongPVNB/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7840606"]])

export default __exports__